import { Controller } from '@hotwired/stimulus'

// Selector "Tipo de artículo" del editor de posts (TC-133-1.1.1.4, US-133-1.1.1).
//
// El `<select>` escribe `contenidos.article_type` y, con él, la plantilla con la
// que se edita el artículo (`regular`, `mejores`, …). Este controller es
// progressive enhancement: al cambiar el selector —y al cargar la página—
// revela/oculta EN CLIENTE los bloques estructurados de la plantilla `mejores`
// (hero, tabla resumen, destacado) según el tipo VIVO seleccionado, sin recargar.
// Antes esos bloques estaban gateados en servidor (`@post.mejores?`) y solo
// aparecían tras Guardar + recarga; ahora elegir "Mejores" los muestra vacíos
// para configurarlos en la misma edición (el guardado en una sola petición lo
// habilita `PostsController#article_type_entrante_mejores?`).
//
// Además reconcilia el toggle `editors_choice` duplicado: el form pinta DOS
// campos `post[editors_choice]` —el del bloque hero (`mejores`) y el standalone
// de la sección admin (`regular`)—. Para que solo UNO se envíe, deshabilita todos
// los inputs (checkbox + hidden companion de `f.check_box`) del contenedor que no
// corresponde al tipo vivo: los inputs deshabilitados no viajan en el submit.
//
// Targets (todos opcionales según la ruta de render — se guarda con `has…Target`):
//   - blocks:                  contenedor de los tres bloques `mejores`.
//   - editorsChoiceHero:       contenedor del toggle editors_choice del hero.
//   - editorsChoiceStandalone: contenedor del toggle editors_choice standalone.
const MEJORES = 'mejores'

export default class extends Controller {
  static targets = ['blocks', 'editorsChoiceHero', 'editorsChoiceStandalone']

  connect () {
    const select = this.element.querySelector('#post_article_type')
    if (select) this.aplica(select.value)
  }

  toggle (event) {
    this.aplica(event.target.value)
  }

  aplica (tipo) {
    const esMejores = tipo === MEJORES

    if (this.hasBlocksTarget) this.blocksTarget.hidden = !esMejores

    // Exactamente un `post[editors_choice]` activo a la vez: el del hero cuando el
    // tipo vivo es `mejores`, el standalone cuando es `regular`.
    if (this.hasEditorsChoiceHeroTarget) {
      this.deshabilitaInputs(this.editorsChoiceHeroTarget, !esMejores)
    }
    if (this.hasEditorsChoiceStandaloneTarget) {
      this.deshabilitaInputs(this.editorsChoiceStandaloneTarget, esMejores)
    }
  }

  deshabilitaInputs (contenedor, deshabilitado) {
    contenedor.querySelectorAll('input').forEach((input) => {
      input.disabled = deshabilitado
    })
  }
}
